import { createSelector } from 'reselect';
import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/bootstrap';
import * as fromLookupTypeActions from './lookup-type.actions';
import { LookupType } from './lookup-type.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: LookupType };
    filters: BaseObjectFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    filters: {
        searchTerm: '',
        sortBy: 'title',
        sortDirection: 1
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromLookupTypeActions.Actions): State {
    switch (action.type) {
        case fromLookupTypeActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromLookupTypeActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromLookupTypeActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromLookupTypeActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.reducer.ts